<template>
<v-text-field hide-details="" :tabindex="tabdeger"  v-model="displayValue" :disabled="Boolean(aktif)" :label="etiket" :name="name" @blur="isInputActive=false" :autocomplete="autocomplete"  @focus="isInputActive=true" >
</v-text-field>




</template>

<script>
export default {
  name: 'currency-input',
  maxValue:0,
  data () {
    return {
      isInputActive: false
    }
  },
  props: ['value', 'tabdeger', 'name', 'id', 'autocomplete', 'etiket','aktif','isPositive','maxValue'],
  computed: {
    displayValue: {
      get: function () {
        if (this.isInputActive) {
          return this.value.toString()
        } else {
          if(this.value != null){
            var result = this.value.toFixed(2); 
            if(this.isPositive){
                var controlMinus = result.search('-');
                  if(controlMinus == 0){
                    this.$emit('input',0);
                    return 0;
                  }
            }
            return result;

          }
        }
      },
      set: function (modifiedValue) {
        let newValue = parseFloat(modifiedValue)
        if (isNaN(newValue)) {
          newValue = 0
        }
        else{
          if (this.maxValue>0)
          {
            if (newValue>this.maxValue)
            {
              newValue=this.maxValue;
            }
          }
        }
        this.$emit('input', newValue)
      }
    }
  }
}
</script>

<style scoped>
</style>
